export const THEME = {
    LIGHT: 1,
    DARK: 3
};

export const LAYOUT = {
    STACK: 'stack',
    COVER: 'cover'
};

export const PARENT_TYPE = 'top-container';

export const CHILD_TYPE = 'top-container/logo-img';
